import {required, sameAs, minLength} from 'vuelidate/lib/validators'

const formData = {
  'currentPassword': {
    size: 4,
    type: 'password',
    name: 'currentPassword',
    label: 'Senha atual',
    value: null
  },
  'plainPassword.first': {
    size: 4,
    type: 'password',
    name: 'password.first',
    label: 'Nova senha',
    value: null,
    hideErrors: true,
    warnings: {
      minLength: 'Deve ter no mínimo 8 caracteres',
      pwValid: 'Deve possuir no mínimo um número e uma letra'
    },
    errors: {
      required: ' '
    }
  },
  'plainPassword.second': {
    size: 4,
    type: 'password',
    name: 'password.second',
    label: 'Repetir a senha',
    value: null,
    errors: {
      samePassword: 'Senhas não conferem'
    }
  }
}
const validations = {
  'plainPassword.first': {
    value: {
      required,
      minLength: minLength(8),
      pwValid: function (value) {
        return this.fn_VALID_PASSWORD(value)
      }
    }
  },
  'plainPassword.second': {
    value: {
      required,
      samePassword: sameAs(function () {
        return this.formData['plainPassword.first'].value
      })
    }
  }
}

export {
  formData,
  validations
}
